import Head from '@/components/layout/Head';

const AGB = () => {
  return (
    <>
      <Head
        title="Allgemeine Geschäftsbedingungen - PayPal Gebührenrechner | paycal.org"
        description="Allgemeine Geschäftsbedingungen für die Nutzung des PayPal Gebührenrechners. Hier finden Sie alle rechtlichen Informationen zur Nutzung unserer Website."
        canonical="https://paycal.org/agb"
      />
      <div className="container mx-auto px-4 py-8">
        <article className="prose max-w-none">
          <h1>Allgemeine Geschäftsbedingungen</h1>

          <h2>1. Geltungsbereich</h2>
          <p>
            Diese Allgemeinen Geschäftsbedingungen gelten für die Nutzung der Website 
            paycal.org (nachfolgend "Website" genannt). Mit der Nutzung der Website 
            erkennen Sie diese Bedingungen an.
          </p>

          <h2>2. Leistungsbeschreibung</h2>
          <p>
            Die Website bietet einen kostenlosen PayPal-Gebührenrechner an. Die 
            Berechnungen basieren auf den offiziellen PayPal-Gebühren, jedoch ohne 
            Gewähr auf Richtigkeit.
          </p>

          {/* Add more sections as needed */}
        </article>
      </div>
    </>
  );
};

export default AGB;